import React, { useState, useEffect } from 'react';
import { FaShoppingCart, FaHeart as EmptyHeart, FaStar } from 'react-icons/fa';
import { FaHeart as FilledHeart } from 'react-icons/fa6';
import { MdOutlineLocalShipping } from "react-icons/md";
import { BsArrowRepeat } from "react-icons/bs";
import { HiOutlineShoppingBag } from "react-icons/hi";
import Lottie from 'lottie-react';
import elevateMartPlaceholder from '../assets/image_loading.json';
import ReactPixel from 'react-facebook-pixel';
import slugify from 'slugify';
import { v4 as uuidv4 } from 'uuid';
import ReactGA from "react-ga4";
import AppConfig from '../config/appConfig'; // path আপনার ফোল্ডার স্ট্রাকচার অনুযায়ী ঠিক করুন

const ProductCard = ({ product, addToCart, toggleFavorite, isFavorite, cartItems, navigate }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  const eventId = uuidv4();

  useEffect(() => {
    setImageLoaded(false);
    setImageError(false);

    if (product.image) {
      const img = new Image();
      img.src = product.image;
      img.onload = () => setImageLoaded(true);
      img.onerror = () => setImageError(true);
    }
  }, [product]);

  const inCart = cartItems.some(item => item.id === (product.productId || product.id));

  const handleBuyNowClick = (e) => {
    e.stopPropagation();

    const productToAdd = {
      ...product,
      id: product.productId || product.id
    };

    addToCart(productToAdd);

    console.log(product);

    function getFbClickId() {
      const match = document.cookie.match(/_fbc=([^;]*)/);
      return match ? match[1] : null;
    }

    function getFbBrowserId() {
      const match = document.cookie.match(/_fbp=([^;]*)/);
      return match ? match[1] : null;
    }

    const externalId = localStorage.getItem('client_id');
    const fbc = getFbClickId();
    const fbp = getFbBrowserId();
    const eventTime = Math.floor(Date.now() / 1000);

    ReactGA.event('add_to_cart', {
      currency: 'BDT',
      value: product.price,
      items: [{
        item_id: product.productId || product.id,
        item_name: product.name,
        item_category: product.category,
        price: product.price,
        quantity: 1
      }],
      event_id: eventId,
    });

    const userData = {
      fbc: fbc,
      fbp: fbp,
      external_id: externalId,
    };

    if (typeof window !== 'undefined' && window.fbq) {
      ReactPixel.track('AddToCart', {
        content_ids: [product.productId || product.id],
        content_name: product.name,
        content_category: product.category,
        currency: 'BDT',
        value: product.price,
        content_type: 'product',
        event_id: eventId,
      }, userData);

      fetch(`${AppConfig.API_BASE_URL}/api/track-addtocart`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          event_name: 'AddToCart',
          productId: product.productId || product.id,
          name: product.name,
          price: product.price,
          fbc: fbc,
          fbp: fbp,
          external_id: externalId,
          event_id: eventId,
          event_time: eventTime
        }),
      }).then(res => res.json())
        .then(data => console.log('AddToCart sent to Flask:', data))
        .catch(err => console.error('Error sending AddToCart to Flask:', err));
    }

    const cartItemForCheckout = {
      ...product,
      quantity: 1,
      selectedSize: product.sizes && product.sizes.length > 0 ? product.sizes[0] : null,
      selectedColor: product.colors && product.colors.length > 0 ? product.colors[0] : null,
    };

    if (navigate) {
      navigate('/checkout', {
        state: {
          cartItems: [cartItemForCheckout]
        }
      });
    }
  };

  const handleAddToCartClick = (e) => {
    e.stopPropagation();

    const productToAdd = {
      ...product,
      id: product.productId || product.id
    };

    addToCart(productToAdd);

    console.log(productToAdd);

    function getFbClickId() {
      const match = document.cookie.match(/_fbc=([^;]*)/);
      return match ? match[1] : null;
    }

    function getFbBrowserId() {
      const match = document.cookie.match(/_fbp=([^;]*)/);
      return match ? match[1] : null;
    }

    const externalId = localStorage.getItem('client_id');
    const fbc = getFbClickId();
    const fbp = getFbBrowserId();
    const eventTime = Math.floor(Date.now() / 1000);
    console.log(eventTime);

    ReactGA.event('add_to_cart', {
      currency: 'BDT',
      value: product.price,
      items: [{
        item_id: product.productId || product.id,
        item_name: product.name,
        item_category: product.category,
        price: product.price,
        quantity: 1
      }],
      event_id: eventId,
    });

    const userData = {
      fbc: fbc,
      fbp: fbp,
      external_id: externalId,
    };

    if (typeof window !== 'undefined' && window.fbq) {
      console.log('Firing Facebook Pixel AddToCart event for product:', product.name);
      ReactPixel.track('AddToCart', {
        content_ids: [product.productId || product.id],
        content_name: product.name,
        content_category: product.category,
        currency: 'BDT',
        value: product.price,
        content_type: 'product',
        event_id: eventId,
      }, userData);

      fetch(`${AppConfig.API_BASE_URL}/api/track-addtocart`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          event_name: 'AddToCart',
          productId: product.productId || product.id,
          name: product.name,
          price: product.price,
          fbc: fbc,
          fbp: fbp,
          external_id: externalId,
          event_id: eventId,
          event_time: eventTime
        }),
      }).then(res => res.json())
        .then(data => console.log('AddToCart sent to Flask:', data))
        .catch(err => console.error('Error sending AddToCart to Flask:', err));
    } else {
      console.warn('Facebook Pixel: AddToCart event not fired. fbq object is not available.');
    }
  };

  const handleCardClick = () => {
    const titleSlug = slugify(product.name, {
      lower: true,
      strict: true,
      trim: true
    });
    if (navigate) {
      navigate(`/product/${product.productId || product.id}/${titleSlug}`);
    }
  };

  const handleFavoriteClick = (e) => {
    e.stopPropagation();
    toggleFavorite(product.id);

    if (!isFavorite(product.id)) {
      if (typeof window !== 'undefined' && window.fbq) {
        console.log('Firing Facebook Pixel AddToWishlist event for product:', product.name);
        ReactPixel.track('AddToWishlist', {
          content_ids: [product.id],
          content_name: product.name,
          currency: 'BDT',
          value: product.price,
          content_type: 'product',
        });
      } else {
        console.warn('Facebook Pixel: AddToWishlist event not fired. fbq object is not available.');
      }
    }
  };

  const isLowStock = product.stock <= 10 && product.stock > 0;
  const isOutOfStock = product.stock === 0;

  const averageRating = product.reviews?.length > 0
    ? (product.reviews.reduce((acc, r) => acc + r.rating, 0) / product.reviews.length)
    : 0;

  const totalReviews = product.reviews?.length || 0;

  return (
    <div
      onClick={handleCardClick}
      className="bg-white cursor-pointer flex flex-col h-full relative overflow-hidden group"
      style={{
        fontFamily: "'Assistant', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
        border: '1px solid #E8E4DC',
        borderRadius: '2px',
        transition: 'box-shadow 0.3s ease, border-color 0.3s ease',
      }}
      onMouseEnter={e => {
        e.currentTarget.style.boxShadow = '0 14px 34px rgba(28,27,25,0.10)';
        e.currentTarget.style.borderColor = '#D8D2C4';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.boxShadow = 'none';
        e.currentTarget.style.borderColor = '#E8E4DC';
      }}
    >
      {/* ── Image Area ── */}
      <div className="relative w-full overflow-hidden" style={{ aspectRatio: '3 / 4', background: '#F7F5F0' }}>

        {/* Badges */}
        {product.discount && (
          <div
            className="absolute top-0 left-0 z-10 text-white text-[10px] md:text-[11px] font-semibold px-3 py-1.5"
            style={{ background: '#9C4A2E', letterSpacing: '0.12em', textTransform: 'uppercase' }}
          >
            {product.discount}
          </div>
        )}
        {product.isPopular && (
          <div
            className="absolute top-0 z-10 text-[10px] md:text-[11px] font-semibold px-3 py-1.5"
            style={{
              left: product.discount ? 'auto' : 0,
              right: product.discount ? 0 : 'auto',
              background: '#FFFFFF',
              color: '#1C1B19',
              border: '1px solid #1C1B19',
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
            }}
          >
            Bestseller
          </div>
        )}

        {/* Favorite */}
        <button
          onClick={handleFavoriteClick}
          className="absolute top-2 right-2 z-20 w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-full transition-all duration-200"
          style={{
            background: 'rgba(255,255,255,0.85)',
            backdropFilter: 'blur(4px)',
            fontSize: '0.95rem',
            opacity: 1,
          }}
        >
          {isFavorite(product.id)
            ? <FilledHeart style={{ color: '#9C4A2E' }} />
            : <EmptyHeart style={{ color: '#1C1B19' }} />}
        </button>

        {/* Product Image */}
        {!imageLoaded && !imageError ? (
          <div className="absolute inset-0 flex items-center justify-center">
            <Lottie animationData={elevateMartPlaceholder} loop autoplay style={{ width: 72, height: 72 }} />
          </div>
        ) : (
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-cover"
            style={{
              transition: 'transform 0.6s cubic-bezier(0.22, 1, 0.36, 1)',
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.06)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; }}
          />
        )}

        {/* Out-of-stock overlay */}
        {isOutOfStock && (
          <div className="absolute inset-0 flex items-center justify-center" style={{ background: 'rgba(255,255,255,0.7)', backdropFilter: 'blur(2px)' }}>
            <span
              className="text-[10px] md:text-xs font-semibold px-3 py-1.5 bg-white"
              style={{ color: '#1C1B19', border: '1px solid #1C1B19', letterSpacing: '0.12em', textTransform: 'uppercase' }}
            >
              Sold Out
            </span>
          </div>
        )}
      </div>

      {/* ── Card Body ── */}
      <div className="flex flex-col flex-grow px-3.5 pt-3.5 pb-3.5 md:px-5 md:pt-5 md:pb-5" style={{ gap: '7px' }}>

        {/* Product Name */}
        <h3
          className="text-gray-900 line-clamp-2"
          style={{
            fontFamily: "'Cormorant Garamond', Georgia, 'Times New Roman', serif",
            fontSize: 'clamp(14px, 2.6vw, 16.5px)',
            fontWeight: 600,
            letterSpacing: '0.005em',
            lineHeight: 1.3,
            minHeight: '2.6em',
            color: '#1C1B19',
          }}
        >
          {product.name}
        </h3>

        {/* Rating */}
        {totalReviews > 0 && (
          <div className="flex items-center gap-1.5">
            <div className="flex items-center gap-0.5">
              {[1, 2, 3, 4, 5].map(i => (
                <FaStar key={i} style={{ fontSize: '10px', color: i <= Math.round(averageRating) ? '#C9A253' : '#E5E1D8' }} />
              ))}
            </div>
            <span style={{ fontSize: '10.5px', color: '#8C8579', letterSpacing: '0.02em' }}>
              ({totalReviews})
            </span>
          </div>
        )}

        {/* Price Row */}
        <div className="flex items-baseline gap-2" style={{ marginTop: '2px' }}>
          <span
            style={{
              fontFamily: "'Cormorant Garamond', Georgia, serif",
              fontSize: 'clamp(17px, 3.2vw, 20px)',
              fontWeight: 700,
              color: '#1C1B19',
              letterSpacing: '-0.01em',
            }}
          >
            ৳{product.price}
          </span>
          {product.originalPrice && (
            <span style={{ fontSize: 'clamp(11px, 2vw, 12.5px)', color: '#B3ADA0', textDecoration: 'line-through' }}>
              ৳{product.originalPrice}
            </span>
          )}
        </div>

        {/* Low Stock */}
        {!isOutOfStock && isLowStock && (
          <p style={{ fontSize: '10.5px', color: '#9C4A2E', fontWeight: 600, letterSpacing: '0.04em', textTransform: 'uppercase', marginTop: '0px' }}>
            Only {product.stock} left
          </p>
        )}

        {/* Sold count */}
        <div
          className="flex items-center gap-1.5"
          style={{
            fontSize: '10.5px',
            color: '#8C8579',
            paddingTop: '8px',
            borderTop: '1px solid #EFEBE2',
            marginTop: '2px',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
          }}
        >
          <HiOutlineShoppingBag style={{ fontSize: '12px' }} />
          <span style={{ fontWeight: 600 }}>{product.buyers} Sold</span>
        </div>

        {/* ── Buttons ── */}
        <div className="flex gap-2 mt-auto pt-2">
          {/* Add to Cart */}
          <button
            onClick={handleAddToCartClick}
            disabled={isOutOfStock}
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '6px',
              padding: 'clamp(7px, 1vw, 10px) clamp(6px, 1vw, 10px)',
              borderRadius: '2px',
              fontSize: 'clamp(9.5px, 1.2vw, 11.5px)',
              fontWeight: 700,
              border: '1px solid #1C1B19',
              cursor: isOutOfStock ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s ease',
              background: isOutOfStock ? '#F2F0EA' : inCart ? '#1C1B19' : 'transparent',
              color: isOutOfStock ? '#B3ADA0' : inCart ? '#fff' : '#1C1B19',
              borderColor: isOutOfStock ? '#E5E1D8' : '#1C1B19',
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
            }}
            onMouseEnter={e => { if (!isOutOfStock) { e.currentTarget.style.background = '#1C1B19'; e.currentTarget.style.color = '#fff'; } }}
            onMouseLeave={e => { if (!isOutOfStock && !inCart) { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#1C1B19'; } }}
          >
            {isOutOfStock ? 'Sold Out' : (
              <>
                <FaShoppingCart style={{ fontSize: '11px' }} />
                <span>{inCart ? 'In Bag' : 'Add'}</span>
              </>
            )}
          </button>

          {/* Buy Now */}
          <button
            onClick={handleBuyNowClick}
            disabled={isOutOfStock}
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '6px',
              padding: 'clamp(7px, 1vw, 10px) clamp(6px, 1vw, 10px)',
              borderRadius: '2px',
              fontSize: 'clamp(9.5px, 1.2vw, 11.5px)',
              fontWeight: 700,
              border: '1px solid #9C4A2E',
              cursor: isOutOfStock ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s ease',
              background: isOutOfStock ? '#F2F0EA' : '#9C4A2E',
              color: isOutOfStock ? '#B3ADA0' : '#FFFFFF',
              borderColor: isOutOfStock ? '#E5E1D8' : '#9C4A2E',
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
            }}
            onMouseEnter={e => { if (!isOutOfStock) { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#9C4A2E'; } }}
            onMouseLeave={e => { if (!isOutOfStock) { e.currentTarget.style.background = '#9C4A2E'; e.currentTarget.style.color = '#FFFFFF'; } }}
          >
            {isOutOfStock ? 'Sold Out' : (
              <>
                <FaShoppingCart style={{ fontSize: '11px' }} />
                <span>Buy Now</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;